<template>
  <el-dialog
    title="余额详情"
    :visible="visible"
    width="900px"
    append-to-body
    :destroy-on-close="true"
    :lock-scroll="false"
    @update:visible="updateVisible">
    <div v-if="data" class="balance-detail">
      <div class="user-info">
        <span>用户：{{ data.username }}</span>
        <span v-if="data.nickname">（{{ data.nickname }}）</span>
        <span v-if="data.mch_id" class="mch-id">商户ID：{{ data.mch_id }}</span>
      </div>
      <el-table :data="tableData" border size="small" class="balance-table">
        <el-table-column prop="asset_label" label="资产类型" width="90" align="center" />
        <el-table-column prop="code" label="币种" width="80" align="center" />
        <el-table-column prop="name" label="名称" min-width="100" align="center" show-overflow-tooltip />
        <el-table-column prop="chain" label="链" width="90" align="center" show-overflow-tooltip />
        <el-table-column prop="balance" label="可用余额" min-width="100" align="center" />
        <el-table-column prop="sj_balance" label="实际余额" min-width="100" align="center" />
        <el-table-column prop="blockedbalance" label="冻结余额" min-width="100" align="center" />
        <el-table-column prop="no_balance" label="未结算" min-width="90" align="center" />
        <el-table-column prop="sum_balance" label="总余额" min-width="100" align="center" />
        <el-table-column prop="yesterday_balance" label="昨日余额" min-width="100" align="center" />
      </el-table>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="updateVisible(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'BalanceDetail',
  props: {
    visible: Boolean,
    data: Object
  },
  computed: {
    tableData() {
      if (!this.data) return [];
      const rows = [this.buildFiatView()];
      const wallets = Array.isArray(this.data.virtual_balances) ? this.data.virtual_balances : [];
      if (wallets.length) {
        wallets.forEach((wallet) => rows.push(this.buildVirtualWalletView(wallet)));
      } else {
        rows.push(this.buildVirtualWalletView({}));
      }
      return rows;
    }
  },
  methods: {
    buildFiatView() {
      const row = this.data || {};
      const slice = row.fiat_balances || {};
      return {
        asset_label: '法币',
        code: slice.code || 'CNY',
        name: slice.name || '人民币',
        chain: '',
        balance: slice.balance || row.balance || '0.00',
        sj_balance: row.fiat_sj_balance || row.sj_balance || '0.00',
        blockedbalance: slice.blockedbalance || row.blockedbalance || '0.00',
        no_balance: slice.no_balance || row.no_balance || '0.00',
        sum_balance: row.fiat_sum_balance || row.sum_balance || '0.00',
        yesterday_balance: row.yesterday_balance || '0.00'
      };
    },
    buildVirtualWalletView(slice) {
      const balance = slice.balance || '0.00';
      const blocked = slice.blockedbalance || '0.00';
      const noBalance = slice.no_balance || '0.00';
      return {
        asset_label: '虚拟币',
        code: slice.code || '',
        name: slice.name || '',
        chain: slice.chain || '',
        balance,
        sj_balance: balance,
        blockedbalance: blocked,
        no_balance: noBalance,
        sum_balance: (Number(balance) + Number(blocked) + Number(noBalance)).toFixed(2),
        yesterday_balance: '0.00'
      };
    },
    updateVisible(value) {
      this.$emit('update:visible', value);
    }
  }
};
</script>

<style scoped>
.user-info {
  margin-bottom: 12px;
  font-size: 14px;
  color: #303133;
}

.mch-id {
  margin-left: 16px;
  color: #909399;
}

.balance-table {
  width: 100%;
}
</style>
